var router = require("./router.js"),
    utils = require("./modules/utils.js");
   // data = require("../data/data.json");



Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function(){
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
})

$.ajax({
    url: 'js/data/data.json',
    cache: false,
    dataType: "json",
}).done(function (data) {
    router.init(data)
});


$(document).ready(function() {

})